import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../../Components/SortableTable";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import {
  formatTimeWithTZOffset,
  getAlertType,
  getToken,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";

const server = EnvSettings.server;

export default function Alerts(props) {
  const classes = useStyles();
  //const [chartData, setChartData] = useState();
  const [recentAlerts, setRecentAlerts] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  function formatAlertData(data) {
    var arr = [];
    data.forEach((element) => {
      arr.push({
        id: element.id,
        alertType: getAlertType(element.alertType, t),
        device: element.Device
          ? element.Device.deviceName || element.Device.serialNumber
          : element.Transport
          ? element.Transport.Device.deviceName ||
            element.Transport.Device.serialNumber
          : undefined,
        active: element.active,
        alertLevel: element.alertLevel,
        message: element.message,
        updatedAt: formatTimeWithTZOffset(element.updatedAt),
      });
    });
    return arr;
  }

  let getRecentAlerts = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_alerts", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setRecentAlerts(formatAlertData(result.alerts));
        }
      });
  };

  let handleRowClick = (data) => {
    history.push("/alerts/" + data);
  };

  useEffect(getRecentAlerts, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {recentAlerts ? (
            <SortableTable
              data={{
                headCells: [
                  {
                    id: "alertType",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.alertType"),
                  },
                  {
                    id: "device",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.device"),
                  },
                  {
                    id: "active",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.active"),
                  },
                  {
                    id: "alertLevel",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.alertLevel"),
                  },
                  {
                    id: "message",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.message"),
                  },
                  {
                    id: "updatedAt",
                    numeric: false,
                    disablePadding: false,
                    label: t("alerts.updatedAt"),
                  },
                ],
                defaultSortRow: "updatedAt",
                handleRowClick: handleRowClick,
                tableData: recentAlerts,
                rowsPerPage: 25,
              }}
            />
          ) : undefined}
          {/*<TransportList data={recentTransports}/> */}
        </Paper>
      </Grid>
    </Grid>
  );
}
